import { Acf } from './types_and_parser/types.mod'
import { mk_pair, none, Option, some, Sum, Unit, unloadedAsyncState, loadingAsyncState } from 'widgets-for-react'
import { BlockData } from '../cms/blocks/types.gen'
import { buttonWrapper, linkWrapper, parseLinkProps } from '../cms/blocks/utils.gen'
import { DownloadBlockProps, DownloadBlockStyle } from '../cms/blocks/widgets/downloadBlock.gen'
import { ExpandBlockProps, ExpandBlockStyle, ExpandProps } from '../cms/blocks/widgets/expandBlock.gen'
import { IframeBlockProps, IframeBlockStyle } from '../cms/blocks/widgets/iframeBlock.gen'
import { LinkBlockProps, LinkBlockStyle, LinkProps } from '../cms/blocks/widgets/linkBlock.gen'
import { LinkGridBlockProps, LinkGridBlockStyle, LinkGridItem } from '../cms/blocks/widgets/linkGridBlock.gen'
import { TextBlockProps, TextBlockStyle } from '../cms/blocks/widgets/textBlock.gen'
import { CustomBlockData } from '../public_site/blocks/custom_blocks/types.mod'
import {
  BSLContactPersonBlockProps,
  BSLContactPersonBlockStyle
} from '../public_site/blocks/custom_blocks/widgets/bsl_contact_person'
import {
  BSLCounterProps,
  BSLCountersBlockProps,
  BSLCountersBlockStyle
} from '../public_site/blocks/custom_blocks/widgets/bsl_counters_block'
import {
  BSLFeaturedContentBlockProps,
  BSLFeaturedContentBlockStyle
} from '../public_site/blocks/custom_blocks/widgets/bsl_featured_content_block'
import { BSLHeaderBlockProps, BSLHeaderBlockStyle } from '../public_site/blocks/custom_blocks/widgets/bsl_header'
import {
  BSLLatestVacanciesBlockProps,
  BSLLatestVacanciesBlockStyle
} from '../public_site/blocks/custom_blocks/widgets/bsl_latest_vacancies'
import { BSLMediaBlockProps, BSLMediaBlockStyle } from '../public_site/blocks/custom_blocks/widgets/bsl_media_block'
import { BSLQuoteBlockProps, BSLQuoteBlockStyle } from '../public_site/blocks/custom_blocks/widgets/bsl_quote_block'
import {
  BSLRichMediaBlockProps,
  BSLRichMediaBlockStyle,
  BSLRichMediaItemProps
} from '../public_site/blocks/custom_blocks/widgets/bsl_richmedia_block'
import {
  BSLShowcaseBlockProps,
  BSLShowcaseBlockStyle,
  BSLShowcaseItemProps
} from '../public_site/blocks/custom_blocks/widgets/bsl_showcase'
import {
  BSLArticleHighlightBlockProps,
  BSLArticleHighlightBlockStyle
} from '../public_site/blocks/custom_blocks/widgets/bsl_article_highlight'
import {
  BSLSuperGridBlockProps,
  BSLSuperGridBlockStyle,
  BSLSuperGridItemProps
} from '../public_site/blocks/custom_blocks/widgets/bsl_super_grid'
import {
  BSLTabItemProps,
  BSLTabsBlockProps,
  BSLTabsBlockStyle
} from '../public_site/blocks/custom_blocks/widgets/bsl_tabs'
import {
  bslBeslismatrixFormBlockClasses,
  bslContactPersonBlockClasses,
  bslCountersBlockClasses,
  bslFeaturedContentBlockClasses,
  bslHeaderBlockClasses, bslLatestEventsBlockClasses,
  bslLatestVacanciesBlockClasses,
  bslQuoteBlockClasses,
  bslRichMediaBlockClasses,
  bslShowcaseBlockClasses,
  bslSuperGridBlockClasses,
  bslTabsBlockClasses,
  downloadBlockClasses,
  expandBlockClasses,
  iframeBlockClasses,
  linkGridBlockClasses,
  linkListBlockClasses,
  mediaBlockClasses,
  textBlockClasses,
  bslArticleHighlightBlockClasses,
  bslVacancySliderBlockClasses
} from '../public_site/blocks/style.mod'
import { case_slider_src, case_slider_srcset, ExtraImages, get_default_data_src, get_default_data_srcset } from '../public_site/utils/extra_images.mod'
import { videoPropsFromHtml } from '../public_site/utils/video_utils'
import { VideoProps } from '../video'
import {
  BSLContactPersonBlock,
  BSLCountersBlock,
  BSLFeaturedContentBlock,
  BSLHeaderBlock,
  BSLLatestVacanciesBlock,
  BSLMediaBlock,
  BSLQuoteBlock,
  BSLRichMediaBlock,
  BSLShowcaseBlock,
  BSLSuperGridBlock,
  BSLTabsBlock,
  CustomBlock,
  BSLVacancyOverviewBlock,
  BSLNewsOverviewBlock,
  BSLLatestEventsBlock,
  BSLEventOverviewBlock,
  BSLArticleHighlightBlock,
  BSLCaseSliderBlock,
  BSLBeslismatrixFormBlock,
  BSLVacancySliderBlock
} from './types_and_parser/custom_blocks.gen'
import {
  Block,
  DownloadBlock,
  ExpandBlock,
  IframeBlock,
  LinkGridBlock,
  LinkListBlock,
  TextBlock
} from './types_and_parser/standard_blocks.gen'
import { BSLVacancyOverviewBlockProps } from '../public_site/blocks/custom_blocks/widgets/bsl_vacancy_overview'
import { BSLNewsOverviewBlockProps } from '../public_site/blocks/custom_blocks/widgets/bsl_news_overview'
import {
  BSLLatestEventsBlockProps,
  BSLLatestEventsBlockStyle
} from "../public_site/blocks/custom_blocks/widgets/bsl_latest_events"
import { BSLEventOverviewBlockStyle, BSLEventOverviewBlockProps } from '../public_site/blocks/custom_blocks/widgets/bsl_event_overview'
import { BSLCaseSliderBlockProps, BSLCaseSliderBlockStyle } from '../public_site/blocks/custom_blocks/widgets/bsl_case_slider'
import { BSLBeslismatrixFormBlockProps, BSLBeslismatrixFormBlockStyle } from '../public_site/blocks/custom_blocks/widgets/bsl_beslismatrix_form'
import { initBeslismatrixFormState } from '../public_site/custom_pages/beslismatrixPage/beslismatrixWizardState'
import { BSLVacancySliderBlockProps, BSLVacancySliderBlockStyle } from '../public_site/blocks/custom_blocks/widgets/bsl_vacancy_slider'

export const TransformStandardBlock = (b: Acf.Block): Block => {
  return { ...b, kind: b.acf_fc_layout } as any
}

export const WordPressBlock_To_WidgetBlock = <CustomBlockData, CustomBlocks extends { kind: CustomBlocks['kind'] }>(
  block: Block,
  index: number,
  mk_block?: (block: CustomBlocks) => Option<CustomBlockData>
): Option<BlockData<CustomBlockData, ExtraImages> | CustomBlockData> => {
  switch (block.kind) {
    // case "cta":
    //   return some<BlockData<CustomBlockData, ExtraImages>>(ctaBlock(block))
    case 'text_block':
      return some<BlockData<CustomBlockData, ExtraImages>>(textBlock(block))
    //  case 'featured_content':
    //    return some<BlockData<CustomBlockData, ExtraImages>>(featuredContent<CustomBlockData>(block))
    case 'download':
      return some<BlockData<CustomBlockData, ExtraImages>>(downloadBlock(block))
    case 'link_list_block':
      return some<BlockData<CustomBlockData, ExtraImages>>(linkListBlock(block))
    case 'iframe':
      return some<BlockData<CustomBlockData, ExtraImages>>(iframeBlock(block))
    case 'link_grid_block':
      return some<BlockData<CustomBlockData, ExtraImages>>(linkGridBlock(block))
    // case "media_block":
    //   return some<BlockData<CustomBlockData, ExtraImages>>(mediaBlock(block))
    case 'expand_block':
      return some<BlockData<CustomBlockData, ExtraImages>>(expandBlock(block, index))
    default: {
      if (mk_block) {
        let maybe_res = mk_block(block as any)
        if (maybe_res.v.kind === 'r') {
          return maybe_res
        }
      }
      console.warn('Unsupported block.', block)
      return none<BlockData<CustomBlockData, ExtraImages> | CustomBlockData>()
    }
  }
}

export const CustomBlock_To_Widget: (block: CustomBlock) => Sum<Unit, CustomBlockData> = block => {
  if (block.kind === 'media_block') {
    return some(bslMediaBlock(block))
  }

  if (block.kind === 'bsl_header') {
    return some(bslHeaderBlock(block))
  }

  if (block.kind === 'quote_block') {
    return some(bslQuoteBlock(block))
  }

  if (block.kind === 'tabs') {
    return some(bslTabsBlock(block))
  }

  if (block.kind === 'featured_content_block') {
    return some(bslFeaturedContentBlock(block))
  }

  if (block.kind === 'counters') {
    return some(bslCountersBlock(block))
  }

  if (block.kind === 'super_grid') {
    return some(bslSuperGridBlock(block))
  }

  if (block.kind === 'showcase') {
    return some(bslShowcaseBlock(block))
  }

  if (block.kind === 'latest_vacancies') {
    return some(bslLatestVacanciesBlock(block))
  }

  if (block.kind === 'contactperson') {
    return some(bslContactPersonBlock(block))
  }

  if (block.kind === 'bsl_richmedia') {
    return some(bslRichMediaBlock(block))
  }

  if (block.kind === 'vacancy_overview') {
    return some(bslVacancyOverviewBlock(block))
  }

  if (block.kind === 'news_overview') {
    return some(bslNewsOverviewBlock(block))
  }

  if (block.kind === 'upcoming_events') {
    return some(bslLatestEventsBlock(block))
  }

  if (block.kind == 'event_overview') {
    return some(bslEventOverviewBlock(block))
  }

  // if(block.kind=="bsl_cta"){}

  if (block.kind == 'highlight_article') {
    return some(bslArticleHighlightBlock(block))
  
  }
  if (block.kind == 'case_slider') {
    return some(bslCaseSliderBlock(block))
  }

  if (block.kind == 'vacancy_slider') {
    return some(bslVacancySliderBlock(block))
  }

  if (block.kind == 'beslismatrix_form') {
    return some(bslBeslismatrixFormBlock(block))
  }

  return none()
}

export const parseVideo: (html: string) => VideoProps = html => {
  let props = videoPropsFromHtml(html)
  return props !== 'unknown' ? props : undefined
}

// export const featuredContent = <CustomBlocks>(block: FeaturedContentBlock): BlockData<CustomBlocks, ExtraImages> => ({
//   kind: 'featuredContentBlock',
//   value: [
//     mk_pair<FeaturedContentBlockProps<CustomBlocks, ExtraImages>, FeaturedContentBlockStyle>(
//       {
//         image: block.image,
//         imageLocation: block.image_position,
//         title: block.title,
//         intro: block.intro,
//         image_size: 'full', // TODO: what to do here?
//         image_alt_text: 'TODO: alt', // TODO: what to do with alt? Add extra field?
//         primary_button: block.primary_button
//           ? buttonWrapper({ title: block.primary_button.title, url: block.primary_button.url })
//           : null,
//         secondary_button: block.secondary_button
//           ? buttonWrapper({ title: block.secondary_button.title, url: block.secondary_button.url })
//           : null,
//         get_default_data_src: get_default_data_src,
//         get_default_data_srcset: get_default_data_srcset
//       },
//       featuredContentClasses(block.image_position)
//     )
//   ]
// })

export const textBlock = <CustomBlocks>(block: TextBlock): BlockData<CustomBlocks, ExtraImages> => ({
  kind: 'textBlock',
  value: mk_pair<TextBlockProps<CustomBlocks, ExtraImages>, TextBlockStyle>(
    {
      title: block.title,
      text: block.text,
      primary_button: block.primary_button
        ? buttonWrapper({ title: block.primary_button.title, url: block.primary_button.url })
        : null,
      link: block.link ? linkWrapper({ title: block.link.title, url: block.link.url }) : null, 
      cta_event_name: block.cta_event_name,
      cta_event_name_secondary: block.cta_event_name_secondary
    },
    textBlockClasses
  )
})

export const iframeBlock = <CustomBlocks, custom_images>(
  block: IframeBlock
): BlockData<CustomBlocks, custom_images> => ({
  kind: 'iframeBlock',
  value: mk_pair<IframeBlockProps, IframeBlockStyle>(
    {
      link: block.url
    },
    iframeBlockClasses(null)
  )
})

export const expandBlock = <CustomBlocks>(block: ExpandBlock, index: number): BlockData<CustomBlocks, ExtraImages> => ({
  kind: 'expandBlock',
  value: mk_pair<ExpandBlockProps, ExpandBlockStyle>(
    {
      block_index: index,
      title: block.title,
      intro: block.intro,
      link: block.link ? linkWrapper({ title: block.link.title, url: block.link.url }) : null,
      items: block.items
        .filter(x => x)
        .map<ExpandProps>((item, i) => ({
          key: `${i}`,
          title: item.title,
          text: item.text,
          open: false
        }))
        .filter(x => x)
    },
    expandBlockClasses
  )
})

export const linkListBlock = <CustomBlocks>(block: LinkListBlock): BlockData<CustomBlocks, ExtraImages> => ({
  kind: 'linkBlock',
  value: mk_pair<LinkBlockProps, LinkBlockStyle>(
    {
      title: block.title,
      intro: block.intro,
      items: block.items.map<LinkProps>((x, i) => x.value && parseLinkProps(x.value, i)).filter(x => x)
    },
    linkListBlockClasses
  )
})

export const downloadBlock = <CustomBlocks>(block: DownloadBlock): BlockData<CustomBlocks, ExtraImages> => ({
  kind: 'downloadBlock',
  value: mk_pair<DownloadBlockProps, DownloadBlockStyle>(
    {
      title: block.title,
      intro: block.intro,
      items: block.items.map((e, i) => ({
        key: `${e.item.title}-${i}`,
        title: e.item.title,
        file_url: e && e.item && e.item.file && e.item.file.url
      }))
    },
    downloadBlockClasses
  )
})

export const linkGridBlock = <CustomBlocks>(block: LinkGridBlock): BlockData<CustomBlocks, ExtraImages> => ({
  kind: 'linkGridBlock',
  value: mk_pair<LinkGridBlockProps<ExtraImages>, LinkGridBlockStyle>(
    {
      title: block.title,
      intro: block.intro,
      items: block.items
        .filter(x => x)
        .map<LinkGridItem<ExtraImages>>(item => ({
          image: item.image,
          image_size: '580w',
          image_alt: item.image_alt,
          title: item.title,
          intro: item.intro,
          link: item.link ? linkWrapper(item.link) : undefined,
          show_image: block.show_image === 'yes'
        }))
        .filter(x => x),
      link: block.link ? linkWrapper(block.link) : undefined,
      show_image: block.show_image === 'yes',
      get_default_data_src,
      get_default_data_srcset
    },
    linkGridBlockClasses(block.items.length)
  )
})

// export const mediaBlock = <CustomBlocks>(block: MediaBlock): CustomBlockData => ({
//   kind: 'media_block',
//   value: mk_pair<MediaBlockProps<ExtraImages>, MediaBlockStyle>(
//     {
//       image: block.kind_media == "image" ? block.image : undefined,
//       image_alt: block.kind_media == "image" ? block.image_alt : undefined,
//       size: 'media_block_large',
//       get_default_data_src: get_default_data_src,
//       get_default_data_srcset: get_default_data_srcset,
//       kind_media: block.kind_media,
//       caption: block.kind_media == "video" ? block.caption : undefined,
//       video: undefined,
//       useCookieBar: false
//     },
//     mediaBlockClasses(block.kind_media)
//   )
// })

export const bslHeaderBlock = <CustomBlocks>(block: BSLHeaderBlock): CustomBlockData => ({
  kind: 'bsl_header',
  value: mk_pair<BSLHeaderBlockProps, BSLHeaderBlockStyle>(
    {
      block_index: 0, // TODO: sebas how to get the index
      title: block.title,
      description: block.description ? block.description : null
    },
    bslHeaderBlockClasses
  )
})

export const bslQuoteBlock = <CustomBlocks>(block: BSLQuoteBlock): CustomBlockData => ({
  kind: 'quote_block',
  value: mk_pair<BSLQuoteBlockProps, BSLQuoteBlockStyle>(
    {
      title: block.title,
      text: block.text,
      subtitle: block.subtitle,
      image: block.image ? block.image : undefined,
      image_alt: block.image_alt ? block.image_alt : undefined,
      link: block.link
        ? linkWrapper({
          title: block.link.title,
          url: block.link.url
        })
        : null
    },
    bslQuoteBlockClasses
  )
})

export const bslSuperGridBlock = <CustomBlocks>(block: BSLSuperGridBlock): CustomBlockData => ({
  kind: 'super_grid',
  value: mk_pair<BSLSuperGridBlockProps<CustomBlockData, ExtraImages>, BSLSuperGridBlockStyle>(
    {
      title: block.title ? block.title : null,
      items: block.items
        .filter(x => x)
        .map<BSLSuperGridItemProps<CustomBlockData, ExtraImages>>((item, i) => ({
          key: `${i}`,
          title: item.title,
          subtitle: item.subtitle,
          description: item.description,
          image: item.image,
          image_alt: item.image_alt,
          image_size: 'super_grid',
          get_default_data_src,
          get_default_data_srcset,
          link: linkWrapper({
            title: item.link.title,
            url: item.link.url
          }),
          download: item.download,
          download_label: item.download_label
        }))
        .filter(x => x)
    },
    bslSuperGridBlockClasses
  )
})

export const bslTabsBlock = <CustomBlocks>(block: BSLTabsBlock): CustomBlockData => ({
  kind: 'tabs',
  value: mk_pair<BSLTabsBlockProps<CustomBlockData, ExtraImages>, BSLTabsBlockStyle>(
    {
      title: block.title,
      intro: block.intro,
      items: block.items
        .filter(x => x)
        .map<BSLTabItemProps<ExtraImages>>((item, i) => ({
          key: `${i}`,
          tab_title: item.tab_title,
          title: item.title ? item.title : null,
          text: item.text,
          kind_media: item.kind_media,
          video: item.kind_media !== 'video' ? undefined : {
            ...parseVideo(item.video),
            width: 960,
            height: 540,
            useCookiebar: false
          },
          image: item.image,
          image_alt: item.image_alt,
          image_size: 'tab',
          get_default_data_src,
          get_default_data_srcset
        }))
        .filter(x => x)
    },
    bslTabsBlockClasses
  )
})

export const bslShowcaseBlock = <CustomBlocks>(block: BSLShowcaseBlock): CustomBlockData => ({
  kind: 'showcase',
  value: mk_pair<BSLShowcaseBlockProps<CustomBlockData, ExtraImages>, BSLShowcaseBlockStyle>(
    {
      title: block.title ? block.title : null,
      subtitle: block.subtitle,
      items: block.items
        .filter(x => x)
        .map<BSLShowcaseItemProps<ExtraImages>>((item, i) => ({
          key: `${i}`,
          title: item.title,
          description: item.description ? item.description : null,
          image: item.image,
          image_alt: item.image_alt,
          image_size: 'super_grid',
          get_default_data_src,
          get_default_data_srcset,
          link: linkWrapper({
            title: item.link.title,
            url: item.link.url
          })
        }))
        .filter(x => x),
      link: block.link ? linkWrapper(block.link) : undefined
    },
    bslShowcaseBlockClasses(block.items.length)
  )
})

export const bslContactPersonBlock = <CustomBlocks>(block: BSLContactPersonBlock): CustomBlockData => ({
  kind: 'contactperson',
  value: mk_pair<BSLContactPersonBlockProps<CustomBlockData, ExtraImages>, BSLContactPersonBlockStyle>(
    {
      title: block.title,
      function: block.function,
      name: block.name,
      email: block.email ? block.email : null,
      phone: block.phone ? block.phone : null,
      image: block.image,
      image_alt: block.image_alt,
      image_size: '210w',
      get_default_data_src,
      get_default_data_srcset
    },
    bslContactPersonBlockClasses
  )
})

export const bslFeaturedContentBlock = <CustomBlocks>(block: BSLFeaturedContentBlock): CustomBlockData => ({
  kind: 'featured_content_block',
  value: mk_pair<BSLFeaturedContentBlockProps<CustomBlockData, ExtraImages>, BSLFeaturedContentBlockStyle>(
    {
      kind_media: block.kind_media,
      imageLocation: block.media_position,
      image: block.image ? block.image : undefined,
      image_size: 'featured_content',
      image_alt_text: block.kind_media === 'image' && block.image ? block.image_alt : undefined,
      video: block.kind_media !== 'video' ? undefined : {
        ...parseVideo(block.video),
        width: 960,
        height: 540,
        useCookiebar: false
      },
      title: block.title,
      intro: block.intro,
      primary_button: block.button ? linkWrapper({ title: block.button.title, url: block.button.url }) : undefined,
      secondary_button: block.link ? linkWrapper({ title: block.link.title, url: block.link.url }) : undefined,
      cta_event_name: block.cta_event_name,
      cta_event_name_secondary: block.cta_event_name_secondary,
      get_default_data_src,
      get_default_data_srcset
    },
    bslFeaturedContentBlockClasses(block.media_position)
  )
})

export const bslCountersBlock = <CustomBlocks>(block: BSLCountersBlock): CustomBlockData => ({
  kind: 'counters',
  value: mk_pair<BSLCountersBlockProps, BSLCountersBlockStyle>(
    {
      items: block.items
        .filter(x => x)
        .map<BSLCounterProps>((item, i) => ({
          key: `${i}`,
          title: item.title,
          subtitle: item.subtitle
        }))
        .filter(x => x)
    },
    bslCountersBlockClasses(block.items.length)
  )
})

export const bslLatestVacanciesBlock = <CustomBlocks>(block: BSLLatestVacanciesBlock): CustomBlockData => ({
  kind: 'latest_vacancies',
  value: mk_pair<BSLLatestVacanciesBlockProps, BSLLatestVacanciesBlockStyle>({}, bslLatestVacanciesBlockClasses)
})

export const bslLatestEventsBlock = <CustomBlocks>(block: BSLLatestEventsBlock): CustomBlockData => ({
  kind: 'upcoming_events',
  value: mk_pair<BSLLatestEventsBlockProps, BSLLatestEventsBlockStyle>({
    category: block.category,
    blocked_events: block.blocked_events ? block.blocked_events.map(x => x.event_name) : null
  }, bslLatestEventsBlockClasses)
})

// Fallback should only count for preexisting event blocks that don't have a title or page size yet
export const bslEventOverviewBlock = <CustomBlocks>(block: BSLEventOverviewBlock): CustomBlockData => ({
  kind: 'event_overview',
  value: mk_pair<BSLEventOverviewBlockProps, BSLEventOverviewBlockStyle>({
    category: block.category,
    title: block.title || '',
    page_size: block.pagination ? parseInt(block.pagination) : 10
  }, bslLatestEventsBlockClasses)
})

export const bslArticleHighlightBlock = <CustomBlock> (block: BSLArticleHighlightBlock): CustomBlockData => ({
  kind: 'highlight_article',
  value: mk_pair<BSLArticleHighlightBlockProps<ExtraImages>, BSLArticleHighlightBlockStyle>({
    article_left: block.article_left,
    articles_right : block.articles_right,
    get_default_data_src,
    get_default_data_srcset,
    image_size: 'large',
    list_image_size: 'super_grid'
  }, bslArticleHighlightBlockClasses)
})

export const bslRichMediaBlock = <CustomBlocks>(block: BSLRichMediaBlock): CustomBlockData => ({
  kind: 'bsl_richmedia',
  value: mk_pair<BSLRichMediaBlockProps, BSLRichMediaBlockStyle>(
    {
      block_index: 0, // TODO: sebas how to get the index
      block_id: block.block_id,
      blob: block.blob,
      title: block.title,
      intro_text: block.intro_text,
      media: block.media.map(media => {
        const res: BSLRichMediaItemProps = {
          media_type: media.media_type,
          video: media.video,
          image: media.image
        }
        return res
      })
    },
    bslRichMediaBlockClasses
  )
})

export const bslMediaBlock = <CustomBlocks>(block: BSLMediaBlock): CustomBlockData => ({
  kind: 'media_block',
  value: mk_pair<BSLMediaBlockProps<ExtraImages>, BSLMediaBlockStyle>(
    {
      image: block.image ? block.image : undefined,
      image_alt: block.kind_media === 'image' && block.image ? block.image_alt : undefined,
      size: 'media_block_large',
      get_default_data_src,
      get_default_data_srcset,
      kind_media: block.kind_media == 'video' ? 'video' : block.kind_media == 'vimeo' ? 'video' : 'image',
      caption: block.kind_media === 'video' ? block.caption : undefined,
      video: block.kind_media == 'video' ? {
        ...parseVideo(block.video),
        width: 960,
        height: 540,
        useCookiebar: false
      } : block.kind_media == 'vimeo' ? {
        ...parseVideo(block.vimeo),
        width: 960,
        height: 540,
        useCookiebar: false
      } : undefined,
      useCookieBar: false
    },
    mediaBlockClasses(block.kind_media == 'video' ? 'video' : block.kind_media == 'vimeo' ? 'video' : 'image')
  )
})

export const bslVacancyOverviewBlock = <CustomBlocks>(block: BSLVacancyOverviewBlock): CustomBlockData => ({
  kind: 'vacancy_overview',
  value: mk_pair<BSLVacancyOverviewBlockProps, BSLRichMediaBlockStyle>(
    {},
    bslLatestVacanciesBlockClasses
  ),
})

export const bslNewsOverviewBlock = <CustomBlocks>(block: BSLNewsOverviewBlock): CustomBlockData => ({
  kind: 'news_overview',
  value: mk_pair<BSLNewsOverviewBlockProps, BSLRichMediaBlockStyle>(
    {},
    bslLatestVacanciesBlockClasses
  ),
})

export const bslCaseSliderBlock = <CustomBlocks>(block: BSLCaseSliderBlock): CustomBlockData => ({
  kind: 'case_slider',
  value: mk_pair<BSLCaseSliderBlockProps<ExtraImages>, BSLCaseSliderBlockStyle>(
    {
      categories: block.case_category,
      get_default_data_src: case_slider_src,
      get_default_data_srcset: case_slider_srcset,
      size: '650x430'
    },
    bslLatestVacanciesBlockClasses
  ),
})

export const bslVacancySliderBlock = <CustomBlocks>(block: BSLVacancySliderBlock): CustomBlockData => ({
  kind: 'vacancy_slider',
  value: mk_pair<BSLVacancySliderBlockProps<ExtraImages>, BSLVacancySliderBlockStyle>(
    {
      get_default_data_src: case_slider_src,
      get_default_data_srcset: case_slider_srcset,
      size: '650x430'
    },
    bslVacancySliderBlockClasses
  ),
})

export const bslBeslismatrixFormBlock = <CustomBlocks>(block: BSLBeslismatrixFormBlock): CustomBlockData => ({
  kind: 'beslismatrix_form',
  value: mk_pair<BSLBeslismatrixFormBlockProps, BSLBeslismatrixFormBlockStyle>(
    {
      beslismatrixFormState: initBeslismatrixFormState()
    },
    bslBeslismatrixFormBlockClasses)
})